import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

function Worldwide() {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  return (
    <div className="page container">

      <Helmet>
        <title>Worldwide Shipping | realgeneric shop</title>
        <meta
          name="description"
          content="Realgeneric shop delivers medicines worldwide with discreet packaging, real-time tracking, and reliable logistics partners."
        />
        <link rel="canonical" href="https://realgenericshop.com/worldwide" />
      </Helmet>

      <h1>Worldwide Shipping – Fast & Reliable Delivery Across the Globe</h1>

      <p>
        <b>Realgeneric shop</b> delivers medicines to customers worldwide.
        With our trusted logistics network, we ensure your order reaches you safely,
        discreetly, and on time — no matter where you are.
      </p>

      <h3>Why Trust Realgeneric shop?</h3>

      <p>
        Along with 450+ affordable medicines and fast processing, we offer:
      </p>

      <ul>
        <li>Global delivery coverage including the US, UK, Europe, Asia, and more</li>
        <li>Discreet packaging to ensure complete privacy</li>
        <li>Trackable shipments for real-time updates</li>
        <li>Safe and reliable delivery of quality medicines</li>
      </ul>

      <h3>Shipping & Tracking Information</h3>

      <p>
        Once your order is verified by our team and processed by licensed pharmacists,
        it is shipped securely. Delivery usually takes 2–3 weeks for the US and
        3–4 weeks for other international locations. Delays may occur due to customs
        or weather conditions.
      </p>

      <p>
        After dispatch, you will receive a tracking ID via email to monitor your shipment.
        If your order is delayed or pending verification, our support team will assist you.
      </p>

      <h3>Contact Information</h3>

      
      <p>International Call/Text: +44 7474 300624</p>
      <p>Email: support@realgenericshop.com</p>

      <h3>FAQs</h3>

      <h4>Do you deliver medicines worldwide?</h4>
      <p>
        Yes. <b>Realgeneric shop</b> delivers to multiple countries worldwide through trusted logistics partners,
        ensuring safe and secure delivery.
      </p>

      <h4>How can I track my order?</h4>
      <p>
        You will receive a tracking ID via email or SMS after dispatch.
        You can use it to monitor your order in real time.
      </p>

      <h4>What if my order is delayed?</h4>
      <p>
        Delays may occur due to customs, weather, or high demand.
        In such cases, contact our support team for assistance.
      </p>

      <h4>Is packaging discreet for international shipping?</h4>
      <p>
        Yes. All orders are shipped in plain, unbranded, tamper-proof packaging
        to ensure complete privacy.
      </p>

      <h4>Do you offer urgent shipping?</h4>
      <p>
        Currently, we provide standard international delivery.
        Express shipping will be introduced in selected regions soon.
      </p>

    </div>
  );
}

export default Worldwide;